export default {
  title: 'Jejda. Stránka nebyla nalezena!',
  subtitle: 'Dosáhli jste okraje pozorovatelného vesmíru Sportya.',
  goHome: 'Pøejít na domovskou stránku',
  contact: 'Dejte nám vìdìt, jak jste se sem dostali, abychom mohli tvoøit lepší svìt (a webové stránky) - <1>contact@sportya.net</1>. \nDíky vám, pøátelé!',
};
